export default "__VITE_ASSET__BmgY$TtZ__"